import React, { useState, useEffect } from "react";
import { Form, Button, Alert, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import logo from "../../../assets/img/illustrations/logo.png";

const SecurityQuestions = ({
  recoveryId,
  questions = [],
  onSubmit,
  onCancel,
  loading,
  error,
}) => {
  const [answers, setAnswers] = useState({});
  const navigate = useNavigate();
  useEffect(() => {
    const init = {};
    questions.forEach(({ id }) => (init[id] = ""));
    setAnswers(init);
  }, [questions]);

  const handleChange = (id, value) => {
    setAnswers(prev => ({ ...prev, [id]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    for (const q of questions) {
      if (!answers[q.id]?.trim()) {
        alert(`Please answer: "${q.questionText}"`);
        return;
      }
    }

    onSubmit({
      recoveryId,
      answers: questions.map(({ id }) => ({
        questionId: id,
        answer: answers[id],
      })),
    });
  };

  // Loading state
  if (!questions.length) {
    return (
      <div className="min-vh-100 d-flex flex-column align-items-center justify-content-center bg-white">
        <Spinner animation="border" variant="success" />
        <p className="mt-3 text-muted">Loading questions...</p>
      </div>
    );
  }

  return (
    <div className="min-vh-100 bg-white d-flex flex-column align-items-center justify-content-center px-3">

      {/* Logo outside card */}
      <div className="mb-4">
        <img
          src={logo}
          alt="Logo"
          style={{ height: "56px", objectFit: "contain" }}
        />
      </div>

      {/* Compact white card */}
      <div
        className="bg-white rounded-3 shadow-sm p-4"
        style={{ maxWidth: "420px", width: "100%" }}
      >
        <div className="text-center mb-4">
          <h4 className="fw-bold mb-1">Verify Your Identity</h4>
          <p className="text-muted small">Answer your security questions</p>
        </div>

        {error && <Alert variant="danger" className="small py-2">{error}</Alert>}

        <Form onSubmit={handleSubmit} className="mt-3">
          {questions.map(({ id, questionText }, i) => (
            <Form.Group key={id} className="mb-3">
              <Form.Label className="fw-medium small">
                {i + 1}. {questionText}
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Your answer"
                value={answers[id] || ""}
                onChange={(e) => handleChange(id, e.target.value)}
                required
                autoComplete="off"
                style={{ height: "44px" }}
              />
            </Form.Group>
          ))}

          <Button
            variant="success"
            type="submit"
            disabled={loading}
            className="w-100 fw-semibold"
            style={{
              backgroundColor: "#28a745",
              border: "none",
              height: "46px",
              fontSize: "1rem"
            }}
          >
            {loading ? (
              <>
                <Spinner animation="border" size="sm" className="me-2" />
                Verifying...
              </>
            ) : (
              "Continue"
            )}
          </Button>
        </Form>

        <div className="text-center mt-3">
          <Button
            variant="link"
            onClick={() => navigate("/authentication/simple/login")}
            disabled={loading}
            navigate="/authentication/simple/login"
            className="text-muted small"
          >
            Back to login
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SecurityQuestions;